module.exports = __webpack_public_path__ + "static/media/248.67211dde.png";